import React from "react"
import {FiArrowRight} from "react-icons/fi";
import Logo from "../../assets/images/logo.png";

interface IAuthSectionProps{
    isBackBtn: boolean,
    handleSection: any,
    children: React.ReactNode
}

const AuthSection:React.FC<IAuthSectionProps> = ({children, isBackBtn = false, handleSection}) => {

    return(
        <div className={"w-[400px] min-h-[550px] bg-white rounded-2xl p-6 flex flex-col space-y-5 shadow-2xl"}>
            <div className={"w-full h-20 py-2 mb-6 grid grid-cols-4"}>
                <div className={`col-span-1 text-right text-3xl cursor-pointer text-secondary my-auto`} onClick={isBackBtn ? () => handleSection("Mobile") : () => {}}>{isBackBtn ? <FiArrowRight /> : null}</div>
                <div className={"col-span-2"}>
                    <a className={"https://www.asasarmaye.com"}><img src={Logo} className={"cursor-pointer mx-auto w-auto h-20"} alt={"آساسرمایه"}/></a>
                </div>
                <div className={"col-span-1"}></div>
            </div>
            {children}
        </div>
    )
}

export default AuthSection